import { useParams } from "react-router-dom";
import { AVERAGE } from "icons";
import React from "react";
import ButtonWithIcon from "@/components/button/icon";
import List from "components/list";
import { StatusCell } from "@/components/status/cell";
import { RenderProfile } from "components/render-profile";
import { getUserFields } from "components/user/config";
import SelfNominationInputSheet from "./input";
import { useState } from "react";
import { useQuad } from "@/modules/performance/context";

const PerformanceReceivedFeedbacks = () => {
  const { quadId } = useParams();
  const [reviews, setReviews] = useState([]);
  const { canSelfNominate } = useQuad();

  const fields = [
    "id",
    "quadrimester",
    "status",
    getUserFields("reviewer"),
    "self_nominated",
  ];

  const filters = {
    quadrimester: { _eq: quadId },
    reviewee: { user: { _eq: "$CURRENT_USER" } },
    reviewer: { user: { _neq: "$CURRENT_USER" } },
  };

  const columns = [
    {
      header: "Reviewer",
      accessorKey: "reviewer",
      cell: ({ getValue }) => <RenderProfile user={getValue()} />,
    },
    {
      header: "Type",
      accessorKey: "self_nominated",
      cell: ({ getValue }) => (getValue() ? "Nominated" : "System"),
    },
    {
      header: "Status",
      accessorKey: "status",
      cell: StatusCell,
    },
  ];

  return (
    <div className="flex-1 h-full flex flex-col">
      {canSelfNominate && <SelfNominationInputSheet reviews={reviews} />}
      <div className="flex-1">
        <List
          title="Feedbacks"
          endPoint="performance_review"
          inlineFilters={true}
          storageKey={`performance_feedbacks-${quadId}`}
          filters={filters}
          columns={columns}
          showSearch={false}
          onDataChange={setReviews}
          renderFilters={() => (
            <ButtonWithIcon icon={AVERAGE} variant="outline" href="average">
              Average
            </ButtonWithIcon>
          )}
          // hidePagination={true}
          meta={{ fields }}
          href={(item) => (item.status === "pending" ? null : item.id)}
        />
      </div>
    </div>
  );
};

export default PerformanceReceivedFeedbacks;
